const body = $('body');
const consentContainer = $('<div class="alert text-white position-fixed" role="alert">');
const consentButton = $('<button class="btn btn-light ml-3" role="button">');

let consentCookie = document.cookie;

consentButton.on('click', function () {
    const now = new Date();
    now.setFullYear(now.getFullYear() + 1);
    
    document.cookie = `cookieConsent=1; expires=${now}; path=/;`;
    consentContainer.remove();
})

consentButton.css({
    padding: '4px 12px',
    fontSize: '11px',
});

consentContainer.css({
    backgroundColor: 'rgba(52,58,64,.85)',
    zIndex: 100000,
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    fontSize: '12px',
    minWidth: 'fit-content',
    maxWidth: '100%',
    margin: '0 0 15px 0'
});

consentContainer.html('Utilizamos cookies essenciais e tecnologias semelhantes de acordo com a nossa <a href="/politica-de-privacidade" class="text-white font-weight-bold" target="_blank">Política de Privacidade</a> e, ao continuar navegando, você concorda com estas condições.');
consentContainer.append(consentButton.text('Ok'));

if (!consentCookie.includes('cookieConsent=1')) {
    body.append(consentContainer);
}